import Listagem from "./Listagem";
import {ModalDetalheAgrotoxicoProvider} from "../ModalDetalheAgrotoxicoContext";
import {ConfirmProvider} from "material-ui-confirm";

export default function ListarTodos() {
    return (
        <>
            <ConfirmProvider defaultOptions={{
                title: 'Excluir item',
                cancellationText: "Cancelar",
                confirmationText: "Excluir",
                confirmationButtonProps: {variant: 'contained', color: 'error'}
            }}>
                <ModalDetalheAgrotoxicoProvider>
                    <Listagem/>

                </ModalDetalheAgrotoxicoProvider>
            </ConfirmProvider>
        </>
    )
}

